import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError } from '../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../u2000Core/context/toast/U2000ToastContext';
import type { U2000AutoCompleteSearchResult } from '../u2000Core/types/U2000AutoCompleteSearchResult';
import { u2000ExtractAutoCompleteResults } from '../u2000Core/utils/u2000ExtractAutoCompleteResults';
import {
  doFindLogicalUnitCategory,
  luHandleAppiError,
  type U2101AutoCompletCriterias,
  type U2101FindLogicalUnitCategoryItem,
} from './U2101Service';
import { NS } from './U2101';

/** Recherche catégorie UL via POST /U2101/findLogicalUnitCategory (BL-0309). */
export function useU2101FindLogicalUnitCategoryHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation();
  const toast = useToast();

  const search = useCallback(
    async (criterias: U2101AutoCompletCriterias): Promise<U2000AutoCompleteSearchResult<U2101FindLogicalUnitCategoryItem>> => {
      try {
        const response = await doFindLogicalUnitCategory(axios, criterias);
        return u2000ExtractAutoCompleteResults<U2101FindLogicalUnitCategoryItem>(response.data);
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError);
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        return { results: [], totalCount: 0, truncated: false };
      }
    },
    [axios, t, toast],
  );

  return { search };
}
